import { ErrorMessage } from '@hookform/error-message';
import { FormControl, InputLabel, Popper, Select, SelectProps } from '@mui/material';
import { useRef } from 'react';
import { Controller } from 'react-hook-form';
import { InputWithControllerProps } from '.';

type SelectWithControllerProps = {
    selectProps: SelectProps;
    options?: JSX.Element[];
};

const SelectWithController = ({
    controllerProps,
    selectProps,
    handleChange,
    errorAsPopper,
    options,
}: SelectWithControllerProps & InputWithControllerProps) => {
    const anchorRef = useRef<HTMLDivElement | null>(null);
    return (
        <Controller
            {...controllerProps}
            render={({ field: { value, onChange } }) => (
                <FormControl fullWidth size="small" ref={anchorRef}>
                    <InputLabel id={`${controllerProps.name}-label`}>
                        {selectProps.label}
                    </InputLabel>
                    <Select
                        {...selectProps}
                        labelId={`${controllerProps.name}-label`}
                        label={selectProps.label}
                        value={value}
                        onChange={(e) => {
                            if (handleChange) {
                                handleChange(e.target.value, onChange);
                            } else {
                                onChange(e.target.value);
                            }
                        }}
                        fullWidth
                    >
                        {options}
                    </Select>
                    <ErrorMessage
                        name={controllerProps.name}
                        render={({ message }) =>
                            errorAsPopper ? (
                                <Popper
                                    open={Boolean(message)}
                                    anchorEl={anchorRef.current}
                                    placement="bottom-start"
                                    disablePortal
                                >
                                    <span className="p-1 text-danger">
                                        {message}
                                    </span>
                                </Popper>
                            ) : (
                                <span className="p-1 text-danger">
                                    {message}
                                </span>
                            )
                        }
                    />
                </FormControl>
            )}
        />
    );
};

export default SelectWithController;
